var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWasherArmBottomHighPressureCold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 159 39",
    style: {
      enableBackground: "new 0 0 159 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00B7FF;}\r\n\t.st1{fill:#00ADEE;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#FF001C;}\r\n\t.st4{fill:#929497;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.17,14.18L82.17,14.18c0.72,0,1.3-0.58,1.3-1.29l0-3.87c0-0.71-0.58-1.29-1.3-1.29h0 c-0.72,0-1.3,0.58-1.3,1.29l0,3.87C80.88,13.6,81.46,14.18,82.17,14.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.18,6.44L82.18,6.44c0.72,0,1.3-0.58,1.3-1.29l0-3.87c0-0.71-0.58-1.29-1.3-1.29h0 c-0.72,0-1.3,0.58-1.3,1.29l0,3.87C80.88,5.87,81.46,6.44,82.18,6.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.17,21.91L82.17,21.91c0.72,0,1.3-0.58,1.3-1.29l0-3.87c0-0.71-0.58-1.29-1.3-1.29h0 c-0.72,0-1.3,0.58-1.3,1.29l0,3.87C80.87,21.33,81.45,21.91,82.17,21.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.46,32.22c0-0.71-0.58-1.29-1.3-1.29h0c-0.72,0-1.3,0.58-1.3,1.29l0,1.64h2.6L83.46,32.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.16,29.64L82.16,29.64c0.72,0,1.3-0.58,1.3-1.29l0-3.87c0-0.71-0.58-1.29-1.3-1.29h0 c-0.72,0-1.3,0.58-1.3,1.29l0,3.87C80.86,29.06,81.45,29.64,82.16,29.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.67,21.76c0.18,0.09,0.37,0.13,0.56,0.13c0.49,0,0.95-0.27,1.17-0.73l1.68-3.49 c0.31-0.64,0.03-1.41-0.61-1.72c-0.65-0.31-1.42-0.03-1.73,0.61l-1.68,3.49C123.74,20.68,124.02,21.45,124.67,21.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.02,14.78c0.18,0.09,0.37,0.13,0.56,0.13c0.49,0,0.95-0.27,1.17-0.73l1.68-3.49 c0.31-0.64,0.03-1.41-0.61-1.72c-0.65-0.31-1.42-0.03-1.73,0.61l-1.68,3.49C127.1,13.7,127.37,14.47,128.02,14.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.31,28.74c0.18,0.09,0.37,0.13,0.56,0.13c0.49,0,0.95-0.27,1.17-0.73l1.68-3.49 c0.31-0.64,0.03-1.41-0.61-1.72c-0.65-0.31-1.42-0.03-1.73,0.61l-1.68,3.49C120.39,27.66,120.66,28.43,121.31,28.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.36,31.62c0.31-0.64,0.04-1.41-0.61-1.72c-0.65-0.31-1.42-0.03-1.73,0.61l-1.61,3.34h2.88L121.36,31.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.62,30.89c-0.31-0.64-1.09-0.91-1.74-0.6c-0.65,0.31-0.92,1.08-0.6,1.72l0.89,1.84h2.89L43.62,30.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.81,14.61c0.22,0.46,0.69,0.73,1.17,0.73c0.19,0,0.38-0.04,0.56-0.13c0.65-0.31,0.92-1.08,0.6-1.72 l-1.7-3.48c-0.31-0.64-1.09-0.91-1.73-0.6c-0.65,0.31-0.92,1.08-0.6,1.72L32.81,14.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,18.09l1.7,3.48c0.23,0.46,0.69,0.73,1.17,0.73c0.19,0,0.38-0.04,0.56-0.13c0.65-0.31,0.92-1.08,0.6-1.72 l-1.7-3.48c-0.31-0.64-1.09-0.91-1.73-0.6C34.46,16.68,34.19,17.45,34.5,18.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.89,25.05l1.7,3.48c0.22,0.46,0.69,0.73,1.17,0.73c0.19,0,0.38-0.04,0.56-0.13 c0.65-0.31,0.92-1.08,0.6-1.72l-1.7-3.48c-0.31-0.64-1.09-0.91-1.73-0.6C37.85,23.64,37.58,24.41,37.89,25.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.58,30.49c0.39,0,0.77-0.17,1.03-0.5l2.4-3.05c0.44-0.56,0.34-1.37-0.23-1.81 c-0.57-0.44-1.38-0.34-1.82,0.22l-2.4,3.05c-0.44,0.56-0.34,1.37,0.23,1.81C144.02,30.4,144.3,30.49,144.58,30.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.21,33.04c0.44-0.56,0.34-1.37-0.23-1.81c-0.57-0.44-1.38-0.34-1.82,0.22l-1.88,2.4h3.29L143.21,33.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.38,24.39c0.39,0,0.77-0.17,1.03-0.5l1.94-2.47c0.44-0.56,0.34-1.37-0.22-1.81 c-0.57-0.44-1.38-0.34-1.82,0.22l-1.94,2.47c-0.44,0.56-0.34,1.37,0.23,1.81C148.81,24.3,149.1,24.39,149.38,24.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.22,33.17c-0.39,0.09-0.69,0.35-0.86,0.69h2.28C64.38,33.34,63.82,33.03,63.22,33.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.49,25.62c-0.7,0.16-1.14,0.85-0.98,1.54l0.86,3.77c0.14,0.6,0.67,1,1.27,1c0.09,0,0.19-0.01,0.29-0.03 c0.7-0.16,1.14-0.85,0.98-1.54l-0.86-3.77C62.89,25.9,62.2,25.46,61.49,25.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.04,10.54c-0.7,0.16-1.14,0.85-0.98,1.54l0.86,3.77c0.14,0.6,0.67,1,1.27,1c0.09,0,0.19-0.01,0.29-0.03 c0.7-0.16,1.14-0.85,0.98-1.54l-0.86-3.77C59.44,10.82,58.75,10.38,58.04,10.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.77,18.08c-0.7,0.16-1.14,0.85-0.98,1.54l0.86,3.77c0.14,0.6,0.67,1,1.27,1c0.09,0,0.19-0.01,0.29-0.03 c0.7-0.16,1.14-0.85,0.98-1.54l-0.86-3.77C61.17,18.36,60.47,17.92,59.77,18.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.2,8.32c0.14,0.6,0.67,1,1.27,1c0.09,0,0.19-0.01,0.29-0.03c0.7-0.16,1.14-0.85,0.98-1.54l-0.86-3.77 C57.71,3.28,57.02,2.84,56.32,3c-0.7,0.16-1.14,0.85-0.98,1.54L56.2,8.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.36,31.86c-0.44-0.56-1.26-0.67-1.82-0.23c-0.57,0.44-0.67,1.25-0.23,1.81l0.32,0.41h3.28L21.36,31.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.15,24.27c0.26,0.33,0.64,0.5,1.03,0.5c0.28,0,0.56-0.09,0.79-0.27c0.57-0.44,0.67-1.25,0.23-1.81 l-2.38-3.06c-0.44-0.56-1.26-0.67-1.82-0.23c-0.57,0.44-0.67,1.25-0.23,1.81L12.15,24.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.54,27.32l2.39,3.06c0.26,0.33,0.64,0.5,1.03,0.5c0.28,0,0.56-0.09,0.79-0.27 c0.57-0.44,0.67-1.24,0.23-1.81l-2.39-3.06c-0.44-0.56-1.26-0.67-1.82-0.23C14.2,25.95,14.1,26.76,14.54,27.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.84,33.21c-0.58-0.13-1.14,0.15-1.41,0.64h2.24C99.5,33.54,99.21,33.3,98.84,33.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.13,31.96c0.1,0.02,0.2,0.03,0.29,0.03c0.59,0,1.13-0.4,1.26-1l0.88-3.77c0.16-0.69-0.27-1.39-0.97-1.55 c-0.7-0.16-1.4,0.27-1.56,0.96l-0.88,3.77C97.99,31.1,98.43,31.8,99.13,31.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.89,24.42c0.1,0.02,0.2,0.03,0.29,0.03c0.59,0,1.13-0.4,1.26-1l0.88-3.77c0.16-0.69-0.27-1.39-0.97-1.55 c-0.7-0.16-1.4,0.27-1.56,0.97l-0.88,3.77C99.75,23.57,100.19,24.26,100.89,24.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.64,16.89c0.1,0.02,0.2,0.03,0.29,0.03c0.59,0,1.13-0.4,1.26-1l0.88-3.77c0.16-0.69-0.27-1.39-0.97-1.55 c-0.7-0.16-1.4,0.27-1.56,0.96l-0.88,3.77C101.51,16.04,101.94,16.73,102.64,16.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.4,9.36c0.1,0.02,0.2,0.03,0.29,0.03c0.59,0,1.13-0.4,1.26-1l0.88-3.77c0.16-0.69-0.27-1.39-0.97-1.55 c-0.69-0.16-1.4,0.27-1.56,0.96l-0.88,3.77C103.26,8.5,103.7,9.2,104.4,9.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.79,15.25c0.05,0.01,0.11,0.01,0.16,0.01c0.65,0,1.21-0.48,1.29-1.13l0.47-3.84 c0.09-0.71-0.42-1.35-1.13-1.44c-0.7-0.08-1.36,0.42-1.45,1.12l-0.47,3.84C91.57,14.53,92.08,15.17,92.79,15.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.74,7.58c0.05,0.01,0.11,0.01,0.16,0.01c0.65,0,1.21-0.48,1.29-1.13l0.47-3.84 c0.09-0.71-0.42-1.35-1.13-1.44c-0.71-0.08-1.36,0.42-1.45,1.12l-0.47,3.84C92.52,6.85,93.03,7.49,93.74,7.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.9,30.6c0.05,0.01,0.11,0.01,0.16,0.01c0.65,0,1.21-0.48,1.29-1.13l0.47-3.84 c0.09-0.71-0.42-1.35-1.13-1.44c-0.71-0.09-1.36,0.42-1.45,1.12l-0.47,3.84C89.68,29.88,90.19,30.52,90.9,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.87,33.32c0.09-0.71-0.42-1.35-1.13-1.44c-0.71-0.08-1.36,0.42-1.45,1.12l-0.1,0.85h2.62L91.87,33.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.84,22.93c0.05,0.01,0.11,0.01,0.16,0.01c0.65,0,1.21-0.48,1.29-1.13l0.47-3.84 c0.09-0.71-0.42-1.35-1.13-1.44c-0.7-0.08-1.36,0.42-1.45,1.12l-0.47,3.84C90.63,22.2,91.13,22.84,91.84,22.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.02,30.11c0.26,0.27,0.6,0.41,0.95,0.41c0.32,0,0.64-0.12,0.89-0.35c0.52-0.49,0.55-1.3,0.06-1.82 l-2.67-2.82c-0.49-0.52-1.32-0.54-1.84-0.06c-0.52,0.49-0.55,1.3-0.06,1.82L3.02,30.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.59,31.16c-0.49-0.52-1.32-0.54-1.84-0.06c-0.52,0.49-0.55,1.3-0.06,1.82l0.88,0.93h3.57L7.59,31.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.74,29.41c0.21,0.13,0.45,0.2,0.69,0.2c0.43,0,0.86-0.21,1.1-0.61l2.06-3.28c0.38-0.6,0.19-1.4-0.41-1.78 c-0.61-0.38-1.41-0.19-1.79,0.41l-2.06,3.28C130.94,28.23,131.13,29.03,131.74,29.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.99,16.26c0.21,0.13,0.45,0.19,0.68,0.19c0.44,0,0.87-0.22,1.13-0.61c0.38-0.6,0.2-1.4-0.4-1.78 c-0.6-0.38-1.41-0.2-1.79,0.4l-0.02,0.04C139.2,15.1,139.39,15.88,139.99,16.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.47,32.27c0.38-0.6,0.19-1.4-0.41-1.78c-0.61-0.38-1.41-0.19-1.79,0.41l-1.85,2.94h3.06L131.47,32.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.86,22.85c0.21,0.13,0.45,0.2,0.69,0.2c0.43,0,0.86-0.21,1.1-0.61l2.06-3.28c0.38-0.6,0.19-1.4-0.41-1.78 c-0.61-0.38-1.41-0.19-1.79,0.41l-2.06,3.28C135.07,21.67,135.25,22.47,135.86,22.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.91,14.53l1.28,3.65c0.19,0.53,0.69,0.87,1.23,0.87c0.14,0,0.29-0.02,0.43-0.07 c0.68-0.23,1.04-0.97,0.8-1.64l-1.28-3.65c-0.24-0.67-0.98-1.03-1.65-0.79C46.03,13.13,45.67,13.86,45.91,14.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.63,10.88c0.19,0.53,0.69,0.87,1.23,0.87c0.14,0,0.29-0.02,0.43-0.07c0.68-0.23,1.04-0.97,0.8-1.64 L45.8,6.38c-0.24-0.67-0.98-1.03-1.65-0.79c-0.68,0.23-1.04,0.97-0.8,1.64L44.63,10.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.47,21.84l1.28,3.65c0.19,0.53,0.69,0.87,1.23,0.87c0.14,0,0.29-0.02,0.43-0.07 c0.68-0.23,1.04-0.97,0.8-1.64l-1.28-3.65c-0.24-0.67-0.98-1.03-1.65-0.79C48.59,20.43,48.23,21.16,48.47,21.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.03,29.14l1.28,3.65c0.19,0.53,0.69,0.87,1.23,0.87c0.14,0,0.29-0.02,0.43-0.07 c0.68-0.23,1.04-0.97,0.8-1.64l-1.28-3.65c-0.24-0.67-0.98-1.03-1.65-0.79C51.15,27.73,50.79,28.47,51.03,29.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.18,32.96c-0.52-0.49-1.34-0.48-1.84,0.03l-0.84,0.87h3.07C153.57,33.53,153.44,33.2,153.18,32.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.99,32.39c0.34,0,0.68-0.13,0.93-0.39l2.71-2.78c0.5-0.51,0.49-1.33-0.03-1.82 c-0.52-0.49-1.34-0.48-1.84,0.03l-2.71,2.78c-0.5,0.51-0.49,1.33,0.03,1.82C154.34,32.27,154.67,32.39,154.99,32.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.07,33.31c-0.08-0.71-0.71-1.22-1.43-1.15c-0.71,0.07-1.23,0.71-1.16,1.42l0.03,0.27h2.61L74.07,33.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.02,16.78c-0.71,0.07-1.23,0.71-1.16,1.42l0.4,3.85c0.07,0.66,0.63,1.15,1.29,1.15c0.05,0,0.09,0,0.14-0.01 c0.71-0.07,1.23-0.71,1.16-1.42l-0.4-3.85C72.37,17.22,71.74,16.71,71.02,16.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.94,7.82c0.05,0,0.09,0,0.14-0.01c0.71-0.07,1.23-0.71,1.16-1.42l-0.41-3.85c-0.07-0.71-0.7-1.22-1.43-1.15 c-0.71,0.07-1.23,0.71-1.16,1.42l0.41,3.85C68.72,7.32,69.28,7.82,69.94,7.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.21,9.09c-0.71,0.07-1.23,0.71-1.16,1.42l0.41,3.85c0.07,0.66,0.63,1.15,1.29,1.15c0.04,0,0.09,0,0.14-0.01 c0.71-0.07,1.23-0.71,1.16-1.42l-0.4-3.85C71.56,9.53,70.91,9.02,70.21,9.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.83,24.47c-0.71,0.07-1.23,0.71-1.16,1.42l0.4,3.85c0.07,0.66,0.63,1.15,1.29,1.15c0.05,0,0.09,0,0.14-0.01 c0.71-0.07,1.23-0.71,1.16-1.42l-0.41-3.85C73.18,24.91,72.53,24.39,71.83,24.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.94,18.68c0.24,0.4,0.67,0.62,1.11,0.62c0.23,0,0.46-0.06,0.68-0.19c0.61-0.37,0.81-1.16,0.43-1.77 l-2.03-3.3c-0.37-0.61-1.17-0.8-1.79-0.43c-0.61,0.37-0.81,1.16-0.43,1.77L22.94,18.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.31,33.83c-0.37-0.61-1.17-0.8-1.79-0.43c-0.19,0.11-0.32,0.27-0.43,0.45h2.23L35.31,33.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.97,21.98l2.03,3.3c0.24,0.4,0.67,0.62,1.11,0.62c0.23,0,0.46-0.06,0.68-0.19 c0.61-0.37,0.81-1.16,0.43-1.77l-2.03-3.3c-0.37-0.61-1.17-0.8-1.79-0.43C24.79,20.57,24.6,21.37,24.97,21.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.03,28.57l2.03,3.3c0.24,0.4,0.67,0.62,1.11,0.62c0.23,0,0.46-0.06,0.68-0.19 c0.61-0.37,0.81-1.16,0.43-1.77l-2.03-3.3c-0.37-0.61-1.17-0.8-1.79-0.43C28.85,27.17,28.66,27.97,29.03,28.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.2,26.49c0.15,0.05,0.29,0.08,0.44,0.08c0.53,0,1.03-0.33,1.22-0.85l1.32-3.64 c0.24-0.67-0.11-1.41-0.78-1.65c-0.68-0.24-1.42,0.11-1.66,0.78l-1.32,3.64C110.17,25.51,110.53,26.25,111.2,26.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.83,19.22c0.15,0.05,0.29,0.08,0.44,0.08c0.53,0,1.03-0.33,1.22-0.85l1.32-3.64 c0.24-0.67-0.11-1.41-0.78-1.65c-0.68-0.24-1.42,0.11-1.66,0.78l-1.32,3.64C112.81,18.24,113.16,18.97,113.83,19.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.57,33.77c0.14,0.05,0.29,0.08,0.44,0.08c0.53,0,1.03-0.33,1.22-0.85l1.32-3.64 c0.24-0.67-0.11-1.41-0.78-1.65c-0.68-0.24-1.42,0.11-1.66,0.78l-1.32,3.64C107.54,32.79,107.89,33.53,108.57,33.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.47,11.94c0.15,0.05,0.29,0.08,0.44,0.08c0.53,0,1.03-0.33,1.22-0.85l1.32-3.64 c0.24-0.67-0.11-1.41-0.78-1.65c-0.68-0.24-1.42,0.11-1.66,0.78l-1.32,3.64C115.44,10.96,115.79,11.7,116.47,11.94z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.89,
    y: 33.85,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 159.322 72.8522)",
    className: "st0",
    width: 155.55,
    height: 5.15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasherArmBottomHighPressureCold);
export default __webpack_public_path__ + "static/media/washer_arm_bottom_high_pressure_cold.9852296fd29fd75d56bb2f70e65fef1f.svg";
export { ForwardRef as ReactComponent };